@if (OTName) {
  <div>
    <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <label for="OT" id="OT">{{this.dialogConfig.data.surgery_type == 'ot' ? "OT":"Cathlab"}}</label>
      <select class="form-control" (change)="getAppointsSlots(otSlots.currentDate, otSlots.OTId)"
        [(ngModel)]="otSlots.OTId" name="otSlots.OTId">
        <option value="">Select</option>
        @for (ot of OTName; track ot) {
          <option [value]="ot.id">{{ot.name}}</option>
        }
      </select>
    </div>
    @if (otSlots.OTId) {
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" style="padding-top: 34px;"
        >
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" [(ngModel)]="otSlots.multiSlotsCheck"
            id="multiSlotsCheck" name="multiSlotsCheck"
            (change)="getAppointsSlots(otSlots.currentDate, otSlots.OTId)">
          <label class="custom-control-label" for="multiSlotsCheck">Multiple Slot</label>
        </div>
      </div>
    }
  </div>
}
@if (showCArm) {
  <dhs-composite-array [current_action]="'ADD'" [resource]="'c_arm_field'" [config]="config"
    [question]="question" [decorator]="self" [items]="cArmArray" (valueAdded)="eventFired($event,compositeArray);"
    #compositeArray>
  </dhs-composite-array>
}
@if (dialogData && dialogData.showSurgery) {
  <dhs-composite-array [current_action]="'ADD'"
    [resource]="additionalSurgeryResource" [config]="config" [decorator]="self" [item_key]="'doctor_id'"
    (valueAdded)="bloodDetail($event)" [items]="dialogData.additionalSurgeryData">
  </dhs-composite-array>
}
@if (dialogData && dialogData.showBlood) {
  <dhs-composite-array [current_action]="'ADD'" [decorator]="self"
    [resource]="'blood_details'" [config]="config" (valueAdded)="bloodDetail($event)"
    [items]="dialogData.blood_required_details">
  </dhs-composite-array>
}

@if (showDateTime) {
  <date-time-filter [startDateEnable]="true" [endDateEnable]="true" [showHideDetails]="false"
    (sendPickerResult)="sendPickerResult($event)">
  </date-time-filter>
}

@if (otSlots.slots) {
  <time-slots [duration]="otSlots.surgeryGradeDurationMin" [multipleSlots]="otSlots.multiSlotsCheck"
    [slots]="otSlots.slots" [key]="'slot_start_time'" [slotTimingInfo]="otSlots.slotTimingInfo"
    (slotResult)="otSlotResult($event)">
  </time-slots>
}
@if (doctorSlots) {
  <time-slots [slots]="doctorSlots" [key]="'slot_start_time'" [colorScheme]="colorScheme"
    (slotResult)="slotResult($event)">
  </time-slots>
}
@if (machineSlots && showDateTime) {
  <time-slots [slots]="machineSlots" [key]="'slot_start_time'"
    [colorScheme]="colorScheme" (slotResult)="machineSlotResult($event)">
  </time-slots>
}
@if ((bloodData != undefined && bloodData.length > 0) || (finalArray != undefined && finalArray.length > 0) || (dialogData && dialogData.blood_required_details != undefined && dialogData.blood_required_details.length > 0) || otObject) {
  <div
    class="col-12 p-0 mt-4 text-center">
    @if (showButton) {
      <button type="submit" class="aside-fixed-button primary-btn submitButton" (click)="onSubmit()">
        {{'button.submit' | translate | async}} <i class="fa fa-check" aria-hidden="true"></i>
      </button>
    }
  </div>
}